import Vue from "vue";
import Vuex from "vuex";
const firebase = require("../../../firebase.config.js");

Vue.use(Vuex);

const UserModule = {
  namespaced: true,
  state: {
    user: {
      data: null,
      disabled: false
    },
    loggedIn: false,
    registered: false,
    firebaseUser: {}
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    isUserDisabled(state) {
      return state.user.disable;
    },
    getFirebaseUser(state) {
      return state.firebaseUser;
    },
    isAuthenticated(state) {
      return state.loggedIn;
    },
    isActivate(state) {
      return state.user.activate;
    },
    registeredDone(state) {
      return state.registered;
    },
    userId() {
      return firebase.auth().currentUser.uid;
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      if (value === true) {
        firebase.analytics.logEvent("login");
      }
      state.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_FIREBASE_USER(state, data) {
      state.firebaseUser = data;
    },
    SET_REGISTERED(state, data) {
      state.registered = data;
    },
    SET_USER_DISABLED(state, data) {
      state.user.disable = data;
    },
    LOGOUT(state) {
      state.user.data = null;
      state.loggedIn = false;
      state.user.disabled = false;
      state.user.registered = false;
      state.firebaseUser = {};
    }
  },
  actions: {
    registeredDone({ commit }) {
      commit("SET_REGISTERED", true);
    },
    logout({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          commit("activities/SET_ACTIVITIES", [], { root: true });
          commit("LOGOUT");
          sessionStorage.clear();
          location.reload();
        });
    },
    async fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user && !user.disable) {
        commit("SET_USER", {
          displayName: user.firstName + " " + user.lastName,
          email: user.email,
          lastName: user.lastName,
          firstName: user.firstName,
          professionalStatus: user.professionalStatus,
          university: user.university,
          fav: user.fav ? user.fav : [],
          likes: user.likes ? user.likes : [],
          uid: user.uid ? user.uid : 0
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
};

export default UserModule;
